'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Player = undefined;

var _wrapper = require('./wrapper/wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _videoPlayer = require('video-player');

var Player = _interopRequireWildcard(_videoPlayer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Player = Player;
exports.Wrapper = _wrapper2.default;
exports.default = _wrapper2.default;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player-react/dist/src/index.js
// module id = 1221
// module chunks = 1 2 3